import {SharePage} from '../pages/h5/share';
import App from '../pages/App';
import {Home} from '../pages/home/home';
import {Product} from '../pages/home/product';
import {ProductR1} from '../pages/home/productR1';
import {ProductM1} from '../pages/home/productM1';
import { News } from 'pages/home/news';
import InstallationVideo from '../pages/home/installationVideo';


import FAQ from '../pages/footer/FAQ';
import IntellectualPropertyRights from '../pages/footer/IntellectualPropertyRights';
import ContactUs from '../pages/footer/ContactUs';
import RefundPolicy from '../pages/footer/RefundPolicy';
import PrivacyPolicy from '../pages/footer/PrivacyPolicy';
import TermsofService from '../pages/footer/TermsofService';
import ReturnRefundPolicy from '../pages/footer/Return&RefundPolicy';
import ShippingPolicy from '../pages/footer/ShippingPolicy';
import Support from '../pages/footer/Support';
import BecomeADistributor from '../pages/footer/BecomeADistributor';
import {AboutUs} from '../pages/footer/aboutUs';
import ErrPage from '../pages/404';
import {appDataDeleteInstruction} from '../pages/other/InstructionsForDeletingAppData';
import { NewsDetail } from 'pages/home/newsDetail';
import { WhereToBuy } from 'pages/home/whereToBuy';
import { DownLoad } from 'pages/downLoad/downLoad';
 

export default [
	{
		name: 'app',
		path: '/',
		component: App,
		children: [
			{
				name: 'home',
				index: true,
				component: Home
			},{
			// 	name: 'home',
			// 	index: true,
			// 	component: Welcome
			// },{
				name: 'home',
				path: '/Home',
				component: Home
			},{
				name: 'Product',
				path: '/Product',
				component: Product
			},{
				name: 'ProductR1',
				path: '/ProductR1',
				component: ProductR1
			},{
				name: 'ProductM1',
				path: '/ProductM1',
				component: ProductM1
			},{
				name: 'News',
				path: '/News',
				component: News
			},{
			// 	name: 'NewsDetail',
			// 	path: '/NewsDetail/:id',
			// 	component: NewsDetail
			// },{
				name: 'AboutUs',
				path: '/AboutUs',
				component: AboutUs
			},{
				name: 'InstallationVideo',
				path: '/InstallationVideo/:type',
				component: InstallationVideo
			},{
				name: 'FAQ',
				path: '/FAQ',
				component: FAQ
			},{
				name: 'IntellectualPropertyRights',
				path: '/IntellectualPropertyRights',
				component: IntellectualPropertyRights
			},{
				name: 'ContactUs',
				path: '/ContactUs',
				component: ContactUs
			},{
				name: 'RefundPolicy',
				path: '/RefundPolicy',
				component: RefundPolicy
			},{
				name: 'PrivacyPolicy',
				path: '/PrivacyPolicy',
				component: PrivacyPolicy
			},{
				name: 'TermsofService',
				path: '/TermsofService',
				component: TermsofService
			},{
				name: 'ReturnRefundPolicy',
				path: '/ReturnRefundPolicy',
				component: ReturnRefundPolicy
			},{
				name: 'ShippingPolicy',
				path: '/ShippingPolicy',
				component: ShippingPolicy
			},{
				name: 'Support',
				path: '/Support',
				component: Support
			},{
				name: 'BecomeADistributor',
				path: '/BecomeADistributor',
				component: BecomeADistributor
			},{
				name: 'WhereToBuy',
				path: '/WhereToBuy',
				component: WhereToBuy
			},{
				name: 'DownLoad',
				path: '/download',
				component: DownLoad
			// },{
			// 	name: 'Instruction',
			// 	path: '/Instruction',
			// 	component: appDataDeleteInstruction
			}
		]
	}, {
		name: '404',
		path: '/404',
		component: ErrPage
	},{
		name: 'welcome',
		path: '/welcome',
		component: SharePage
	},{
		name: 'NewsDetail',
		path: '/NewsDetail/:id',
		component: NewsDetail
	},{
		name: 'Instruction',
		path: '/Instruction',
		component: appDataDeleteInstruction
	}
]
